import { KbChapterPage } from "@/components/kb/KbChapterPage";

export function Chapter002() {
  return <KbChapterPage slug="chapter-002" />;
}

(Chapter002 as unknown as { path: string }).path = "/theory-album/002";
